import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TitleService {

  /*========================================
                  Variables
  =========================================*/

  title: string = 'VOP';
  notificationCount: number = 0;

  constructor(
    private titleService: Title
  ) {};

  /*========================================
              Configure service
  =========================================*/

  setTitle(title) : void {
    this.title = title;
    this.titleService.setTitle((this.notificationCount > 0) ? '(' + this.notificationCount + ') ' + this.title : this.title);
  };

  getTitle() : string {
    return this.titleService.getTitle();
  };

  setNotificationCount(notificationCount) : void {
    this.notificationCount = notificationCount;
    this.setTitle(this.title);
  }

  getNotificationCount() : number {
    return this.notificationCount;
  };

}
